/* eslint-disable react/no-danger */
import React, { useState } from "react";
// ANT DESIGN COMPONENTS
import { Button, Tooltip } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
// INTERFACES
import {
	AddItemsInterface,
	DataRepresentationInterface,
} from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentAddItems({
	data,
	setData,
}: {
	data: AddItemsInterface;
	setData: (newValue: AddItemsInterface) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [itemName, setItemName] = useState<string>("");
	const [dataType, setDataType] = useState<DataRepresentationInterface>("i16");

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeValue = (newValue: string, variableName: string) => {
		const copy = structuredClone(data);
		if (variableName === "group_name") {
			copy.group_name = newValue;
		}
		setData(copy);
	};

	const formatJsonWithColors = (obj: any) => {
		const json = JSON.stringify(obj, null, 4)
			.replace(/"([^"]+)"\s*:/g, '<span style="color:#9cdcfe;">"$1"</span>:')
			.replace(/: "([^"]*)"/g, ': <span style="color:#ce9178;">"$1"</span>')
			.replace(/:\s*(\d+)/g, ': <span style="color:#b5cea8;">$1</span>');
		return json;
	};

	const onChangeValueItemName = (newValue: string) => {
		setItemName(newValue);
	};

	const onClickAddNewItemName = () => {
		const copy = structuredClone(data);
		copy.item_names.push(itemName);
		setData(copy);
		setItemName("");
	};

	const onClickRemoveItemName = (index: number) => {
		const copy = structuredClone(data);
		copy.item_names.splice(index, 1);
		setData(copy);
	};

	const onChangeValueDataType = (newValue: any) => {
		setDataType(newValue);
	};

	const onClickAddNewDataType = () => {
		const copy = structuredClone(data);
		copy.data_types.push(dataType);
		setData(copy);
		setItemName("");
	};

	const onClickRemoveDataType = (index: number) => {
		const copy = structuredClone(data);
		copy.data_types.splice(index, 1);
		setData(copy);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<FormInputText
				inputValue={data.group_name}
				inputLabelName={t("general.groupName")}
				inputOnChange={onChangeValue}
				inputVariableName='group_name'
				isRequired
				disabledInput={false}
				
			/>
			<FormInputText
				inputValue={itemName}
				inputLabelName={t("general.name")}
				inputOnChange={onChangeValueItemName}
				inputVariableName=''
				isRequired
				disabledInput={false}
				
			/>
			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired'>*</span>
						<span className='drawer__text'>{t("general.responses")}</span>
					</div>
					<div className='generalStyles__width100'>
						{data.item_names.map((item: string, itemIndex: number) => (
							<div
								key={itemIndex}
								className='mb-3'
								style={{
									backgroundColor: "#1f1f1f",
									borderRadius: "5px",
									fontSize: "9px",
									padding: "10px",
								}}
							>
								<div
									style={{
										width: "100%",
									}}
								>
									<pre
										style={{
											width: "100%",
											color: "#dcdcdc",
											padding: "10px",
											borderRadius: "8px",
											overflowX: "auto",
										}}
										dangerouslySetInnerHTML={{
											__html: formatJsonWithColors(item),
										}}
									/>
									<div className='generalStyles__flexCenter'>
										<Tooltip title={t("general.delete")}>
											<Button
												onClick={() => {
													onClickRemoveItemName(itemIndex);
												}}
												className='buttonStyle__29'
												shape='circle'
												icon={<FontAwesomeIcon icon={faTrash} />}
											/>
										</Tooltip>
									</div>
								</div>
							</div>
						))}
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>
			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired' />
					</div>
					<div className='generalStyles__width100'>
						<Button
							onClick={onClickAddNewItemName}
							className='buttonStyle__28 generalStyles__width100'
						>
							<FontAwesomeIcon icon={faPlus} className='generalStyles__mrFix' />
							{t("general.add")}
						</Button>
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>
			<FormInputText
				inputValue={dataType}
				inputLabelName={t("general.dataType")}
				inputOnChange={onChangeValueDataType}
				inputVariableName=''
				isRequired
				disabledInput={false}
				
			/>
			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired'>*</span>
						<span className='drawer__text'>{t("general.responses")}</span>
					</div>
					<div className='generalStyles__width100'>
						{data.data_types.map(
							(item: DataRepresentationInterface, itemIndex: number) => (
								<div
									key={itemIndex}
									className='mb-3'
									style={{
										backgroundColor: "#1f1f1f",
										borderRadius: "5px",
										fontSize: "9px",
										padding: "10px",
									}}
								>
									<div
										style={{
											width: "100%",
										}}
									>
										<pre
											style={{
												width: "100%",
												color: "#dcdcdc",
												padding: "10px",
												borderRadius: "8px",
												overflowX: "auto",
											}}
											dangerouslySetInnerHTML={{
												__html: formatJsonWithColors(item),
											}}
										/>
										<div className='generalStyles__flexCenter'>
											<Tooltip title={t("general.delete")}>
												<Button
													onClick={() => {
														onClickRemoveDataType(itemIndex);
													}}
													className='buttonStyle__29'
													shape='circle'
													icon={<FontAwesomeIcon icon={faTrash} />}
												/>
											</Tooltip>
										</div>
									</div>
								</div>
							),
						)}
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>
			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired' />
					</div>
					<div className='generalStyles__width100'>
						<Button
							onClick={onClickAddNewDataType}
							className='buttonStyle__28 generalStyles__width100'
						>
							<FontAwesomeIcon icon={faPlus} className='generalStyles__mrFix' />
							{t("general.add")}
						</Button>
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>
		</div>
	);
}
